<template>
  <span class="breadcrumbs">
    <a
      v-if="!isAtRoot"
      href="#"
      class="quote-bc-link"
      @click.prevent="$emit('navigate-all')"
    >All categories</a>
    <span v-else class="quote-bc-current">All categories</span>
    <template v-if="viewMode === 'search'">
      <span class="quote-bc-sep">/</span>
      <span v-if="!taskCode" class="quote-bc-current"><span class="quote-bc-emoji" aria-hidden="true">🤖</span> Results</span>
      <span v-else class="quote-bc-parent"><span class="quote-bc-emoji" aria-hidden="true">🤖</span> Results</span>
      <template v-if="taskCode">
        <span class="quote-bc-sep">/</span>
        <span class="quote-bc-current">{{ taskCode }}</span>
      </template>
    </template>
    <template v-else>
      <template v-for="entry in displaySegmentEntries" :key="'entry-' + entry.originalIdx">
        <span class="quote-bc-sep">/</span>
        <a
          v-if="entry.isLink"
          href="#"
          class="quote-bc-link"
          @click.prevent="$emit('navigate-segment', entry.originalIdx)"
        >{{ entry.seg.name }}</a>
        <span v-else class="quote-bc-current">{{ entry.seg.name }}</span>
      </template>
      <template v-if="taskCode">
        <span class="quote-bc-sep">/</span>
        <span class="quote-bc-current">{{ taskCode }}</span>
      </template>
    </template>
  </span>
</template>

<script>
const MOBILE_BREADCRUMB_MQ = '(max-width: 767px)'

export default {
  name: 'Breadcrumbs',
  props: {
    segments: {
      type: Array,
      default: function () { return [] }
    },
    viewMode: {
      type: String,
      default: 'browse'
    },
    isAtRoot: {
      type: Boolean,
      default: true
    },
    lastSegmentIsCurrent: {
      type: Boolean,
      default: true
    },
    taskCode: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      isMobileBreadcrumb: false
    }
  },
  computed: {
    displaySegmentEntries: function () {
      const segs = this.segments || []
      if (!segs.length) return []

      const entries = segs.map(function (seg, idx) {
        return { seg: seg, originalIdx: idx }
      })

      if (!this.isMobileBreadcrumb || this.viewMode === 'search') {
        const lastSegmentIsCurrent = this.lastSegmentIsCurrent
        return entries.map(function (entry, idx) {
          return Object.assign({}, entry, {
            isLink: idx < segs.length - 1 || !lastSegmentIsCurrent
          })
        })
      }

      if (!this.lastSegmentIsCurrent) {
        const last = entries[entries.length - 1]
        return [{
          seg: last.seg,
          originalIdx: last.originalIdx,
          isLink: true
        }]
      }

      if (entries.length === 1) {
        return [{
          seg: entries[0].seg,
          originalIdx: entries[0].originalIdx,
          isLink: false
        }]
      }

      const parent = entries[entries.length - 2]
      const current = entries[entries.length - 1]
      return [
        { seg: parent.seg, originalIdx: parent.originalIdx, isLink: true },
        { seg: current.seg, originalIdx: current.originalIdx, isLink: false }
      ]
    }
  },
  methods: {
    syncMobileBreadcrumb: function () {
      if (typeof window === 'undefined' || !window.matchMedia) {
        this.isMobileBreadcrumb = false
        return
      }
      this.isMobileBreadcrumb = window.matchMedia(MOBILE_BREADCRUMB_MQ).matches
    }
  },
  mounted: function () {
    this.syncMobileBreadcrumb()
    if (typeof window !== 'undefined' && window.matchMedia) {
      this._mobileBreadcrumbMq = window.matchMedia(MOBILE_BREADCRUMB_MQ)
      this._onMobileBreadcrumbChange = this.syncMobileBreadcrumb.bind(this)
      if (this._mobileBreadcrumbMq.addEventListener) {
        this._mobileBreadcrumbMq.addEventListener('change', this._onMobileBreadcrumbChange)
      } else if (this._mobileBreadcrumbMq.addListener) {
        this._mobileBreadcrumbMq.addListener(this._onMobileBreadcrumbChange)
      }
    }
  },
  beforeUnmount: function () {
    if (!this._mobileBreadcrumbMq || !this._onMobileBreadcrumbChange) return
    if (this._mobileBreadcrumbMq.removeEventListener) {
      this._mobileBreadcrumbMq.removeEventListener('change', this._onMobileBreadcrumbChange)
    } else if (this._mobileBreadcrumbMq.removeListener) {
      this._mobileBreadcrumbMq.removeListener(this._onMobileBreadcrumbChange)
    }
  }
}
</script>

<style>
.breadcrumbs {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  white-space: nowrap;
  max-width: 100%;
  font-family: var(--font-regular);
  font-size: 14px;
  line-height: 17px;
}

.breadcrumbs .quote-bc-link,
.breadcrumbs .quote-bc-current,
.breadcrumbs .quote-bc-parent,
.breadcrumbs .quote-bc-sep,
.breadcrumbs .quote-bc-emoji {
  flex-shrink: 0;
}

.breadcrumbs .quote-bc-parent {
  font-size: 14px;
  line-height: 17px;
  color: #707070;
}
</style>
